/* eslint-disable react-hooks/rules-of-hooks */
import React, { memo, useEffect, useState } from "react";
import { SubscribeProps } from "./Subscribe.props";
import cn from "classnames";
import styles from "./Subscribe.module.scss";
import TextField from "../TextField/TextField";
import ReCAPTCHA from "react-google-recaptcha";
import { REACT_RECAPTCH_KEY } from "../../../config";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { ErrorMessage } from "@hookform/error-message";
import { SubscribeInterface } from "../../../http/interface.api";
import { FieldsTypes, InpitTypes } from "../TextField/TextField.props";
import Button from "../Button/Button";
import { toast } from "react-toastify";
import api from "../../../http/api";
import { useIntl } from "react-intl";

type FormValues = {
  email: string;
  name: string;
};

function Subscribe({ className }: SubscribeProps) {
  const { formatMessage } = useIntl();
  const [openSubs, setOpenSubs] = useState<boolean>(false);
  const [postData, setPostData] = useState<SubscribeInterface>({ email: "", name: "" });
  const validationSchema = Yup.object().shape({
    email: Yup.string().email("Email is invalid"),
    telegramOrNumber: Yup.string().notRequired(),
  });
  const [reCaptcha, setReCaptcha] = useState<any>();
  const clickSubs = () => {
    setOpenSubs(!openSubs);
    setPostData({ email: "", name: "" });
  };
  const {
    handleSubmit,
    formState: { errors },
    reset,
    register,
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      email: "",
      name: "",
    },
  });

  const recaptchaResponsed = async (response: string) => {
    try {
      toast.info("Subscribing...");
      const res = await api.subscribe(postData, response);
      if (res.Status === "error") {
        setOpenSubs(false);
        reCaptcha && reCaptcha.reset();
        return toast.error("Something goes wrong! Please, try again later");
      } else {
        setOpenSubs(false);
        reCaptcha && reCaptcha.reset();
        return toast.success("You have subscribed to the newsletter");
      }
    } catch (e) {
      console.error(e);
      toast.error("Something goes wrong! Please, try again later");
    }
  };
  const onSubmit = async (data: FormValues) => {
    setPostData({
      email: data.email,
      name: data.name,
    });
    reset({ email: "", name: "" });
  };

  const onError = (type: string) => (
    <ErrorMessage
      render={({ message }) => <div style={{ color: "red", margin: "5px 0" }}>{message}</div>}
      errors={errors}
      name={type as keyof FormValues}
    />
  );
  return (
    <div
      className={cn(className, styles.subscribe, {
        [styles.openSubs]: openSubs,
      })}
    >
      <h4
        onClick={clickSubs}
        className={cn({
          [styles.openSubs]: openSubs,
        })}
      >
        {formatMessage({ id: "main.subscribe" })}
      </h4>
      <form
        className={cn(styles.subscribeBlock, {
          [styles.ok]: !!postData.email || !!postData.name,
        })}
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          field={FieldsTypes.input}
          type={InpitTypes.email}
          placeholder='E-mail'
          validation
          validRegister={{ ...register("email") }}
          autoComplete='off'
          color='primary'
          className={styles.field}
          subscribe
        />
        {onError("email")}
        <TextField
          field={FieldsTypes.input}
          type={InpitTypes.text}
          placeholder='Telegram ID or Phone number'
          validation
          validRegister={{ ...register("name") }}
          autoComplete='off'
          color='primary'
          className={styles.field}
          subscribe
        />
        <Button className={styles.button} type='submit'>
          {formatMessage({ id: "main.subscribe" })}
        </Button>
        {REACT_RECAPTCH_KEY && openSubs && (
          <div
            className={cn(styles.recaptcha, {
              [styles.active]: !!postData.email || !!postData.name,
              // [styles.reset]: !!error || !!success,
            })}
          >
            <ReCAPTCHA
              sitekey={REACT_RECAPTCH_KEY}
              onChange={(response) => response && recaptchaResponsed(response)}
              ref={(e) => setReCaptcha(e)}
            />
          </div>
        )}
        {/* {(!!error || !!success) && (
          <div
            className={cn(styles.status, {
              [styles.error]: !!error,
              [styles.success]: !!success,
            })}
          >
            {error && error}
            {success && success}
          </div>
        )} */}
      </form>
    </div>
  );
}
export default memo(Subscribe);
